import React from 'react';

import { Label, Wrapper } from './wrapper';

type InputGroupProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  children: React.ReactNode;
  label?: string;
};

const InputGroup = ({ children, label }: InputGroupProps) => (
  <Wrapper>
    {label && <Label>{label}</Label>}
    {children}
  </Wrapper>
);

export default InputGroup;
